import { useState } from "react";
import { motion } from "framer-motion";
import { ZoomIn } from "lucide-react";
import { T } from "@/lib/i18n";

const ZOOM = 2.6;

export function ProductZoom({ src, alt }) {
  const [on, setOn] = useState(false);
  const [pos, setPos] = useState({ x: 50, y: 50 });

  const move = (clientX, clientY, el) => {
    const r = el.getBoundingClientRect();
    setPos({ x: Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100)), y: Math.min(100, Math.max(0, ((clientY - r.top) / r.height) * 100)) });
  };

  return (
    <div
      data-testid="product-zoom"
      className={`absolute inset-0 ${on ? "cursor-zoom-out" : "cursor-zoom-in"}`}
      style={{ touchAction: on ? "none" : "auto" }}
      onPointerEnter={(e) => { if (e.pointerType === "mouse") { setOn(true); move(e.clientX, e.clientY, e.currentTarget); } }}
      onPointerLeave={(e) => { if (e.pointerType === "mouse") setOn(false); }}
      onPointerMove={(e) => { if (on) move(e.clientX, e.clientY, e.currentTarget); }}
      onClick={(e) => { if (!window.matchMedia("(hover: hover)").matches) { move(e.clientX, e.clientY, e.currentTarget); setOn((v) => !v); } }}
    >
      <motion.img initial={{ scale: 1.2 }} animate={{ scale: 1 }} transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }} src={src} alt={alt} fetchPriority="high" width="800" height="800" className="relative h-full w-full object-contain p-6 drop-shadow-[0_30px_60px_rgba(0,0,0,0.6)]" />
      <div
        data-testid="product-zoom-lens"
        aria-hidden="true"
        className={`absolute inset-0 bg-[var(--ink-2)] bg-no-repeat transition-opacity duration-300 ${on ? "opacity-100" : "pointer-events-none opacity-0"}`}
        style={{ backgroundImage: `url("${src}")`, backgroundSize: `${ZOOM * 100}%`, backgroundPosition: `${pos.x}% ${pos.y}%` }}
      />
      <span data-testid="product-zoom-hint" className={`pointer-events-none absolute bottom-4 right-4 flex items-center gap-2 rounded-full bg-[rgba(11,8,9,0.7)] px-3 py-1.5 text-xs text-[var(--parchment)] backdrop-blur-md transition-opacity duration-300 ${on ? "opacity-0" : "opacity-100"}`}>
        <ZoomIn className="h-3.5 w-3.5 text-[var(--gold-soft)]" />
        <span className="hidden [@media(hover:hover)]:inline"><T>Survolez pour zoomer</T></span>
        <span className="[@media(hover:hover)]:hidden"><T>Touchez pour zoomer</T></span>
      </span>
    </div>
  );
}
